<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
        <!-- Osnov za pravo na go -->
        <div class="row">
            <div class="col-lg-8 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist
                            [ModelName]="'osnovzago'"
                            [GetName]="'get'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="true"
                            formControlName="OsnovZaGoID" [Label]="'OSNOVZAPRAVONAGO.OSNOVZAGO.SINGULAR'"
                            (OnItemSelected)="onOsnovZaPravoNaGoSelect($event)">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.OsnovZaGoID.invalid">
                            <span *ngFor="let validation of errorMessages.OsnovZaGoID">
                                <span class="error-message" *ngIf="fc.OsnovZaGoID.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Opis -->
            <div class="col-lg-4 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'NUMERIC'" name="numberBrojDana" formControlName="BrojDana" #focusElement
                            [MaxLength]="4" [ngClass]="{'is-invalid': submitted && fc.BrojDana.invalid}"
                            [Label]="'OSNOVZAPRAVONAGO.BROJDANA.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.BrojDana.invalid">
                            <span *ngFor="let validation of errorMessages.BrojDana">
                                <span class="error-message" *ngIf="fc.BrojDana.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>